<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiMenu } from "@mdi/js";
export default {
  name: "MdiMenu",
  data() {
    return {
      svgPath: mdiMenu,
    };
  },
};
</script>
